var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatBubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.9141 19.256C6.10123 20.8468 4.16672 21.265 2.50598 21.0171C2.35023 20.9938 2.23271 20.9688 2.15746 20.9485C1.41681 20.7484 1.34465 19.7454 2.04931 19.4451C3.03405 19.0255 3.62427 18.2491 3.91486 17.2794C1.45598 15.4299 0 12.754 0 9.8635C0 4.38775 5.17278 0 11.5 0C17.8272 0 23 4.38775 23 9.8635C23 15.3387 17.8269 19.727 11.5 19.727C10.273 19.727 9.07185 19.5623 7.92896 19.2429C7.92401 19.2473 7.91905 19.2517 7.9141 19.256Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatBubble);
export default __webpack_public_path__ + "static/media/chatBubble.c66ee60f0c7972d339c1917f31d3df57.svg";
export { ForwardRef as ReactComponent };